import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { AddProductComponent } from '../../admin/sub-admin/add-product/add-product.component';
import { REGION_CATEGORY_IMAGE_LIST } from '../marketplace/marketplace.model';
import moment from 'moment';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { BehaviorSubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-shop-page',
  templateUrl: './shop-page.component.html',
  styleUrls: ['./shop-page.component.scss']
})
export class ShopPageComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  viewGrid: boolean = true;
  public tabs = [
    { title: 'Sell' },
    { title: 'Rent' },
    { title: 'Donate' },
    { title: 'Hide' },
    { title: 'History' },
  ];
  public typeMask = {
    bless: 'Donate',
    rental: 'Rent',
    sold: 'Sell'
  }
  public STATUS = [
    { value: 0, label: 'Inactive' },
    { value: 1, label: 'Active' },
    { value: 2, label: 'Hidden' },
    { value: 3, label: 'Sold' },
    { value: 4, label: 'Out of Stock' },
  ]
  updateSelMenu(index: number) {
    this.selectMenu(index)
  }
  @ViewChild('AddShop') addProductComponent: AddProductComponent;
  public categoriesList: Array<any> = [];
  public regionList = REGION_CATEGORY_IMAGE_LIST;
  public selectedCategoryName = null;
  public selectedSubCategoryName = '';
  public shopExist: boolean = true;
  // public shopInfo: any = null;
  public imgUrl = environment.ImageUrl;
  public addedCategoryList: Array<any> = [];
  public addedSubCategoryList: Array<any> = [];
  public selectedRegionForDD = '';
  public commonModalRef: any = null;
  public selectedSellOption: any = null;

  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private modalService: NgbModal,
    config: NgbDropdownConfig,
    private sharedService: SharedService,
    private customerService: CustomerService,
    private local: LocalServiceService,
    public commonService: CommonService,
  ) {
    config.placement = 'top-start';
    config.autoClose = false;
    this._getShopInfo();
    this.getAllProductList(true);
  }

  ngOnInit(): void {
    this.sharedService.initMarketProfile$.subscribe((params: any) => {

      this.update('productUpdate');

      this.selectMenu(this.selMenu)
    });
  }
  isNumber(value: any): boolean {
    return !isNaN(Number(value));
  }
  sortDirection: 'asc' | 'desc' = 'asc';
  sortName: string = '';
  sortProducts(property: any): void {
    this.sortName = property;
    const multiplier = this.sortDirection === 'asc' ? 1 : -1;

    this.productAllProductList.sort((a, b) => {
      let comparison = 0;

      if (property === 'name') {
        comparison = a.name.localeCompare(b.name);
      } else if (property === 'price') {
        comparison = a.memberShopProductsVariations[0].key - b.memberShopProductsVariations[0].key;
      } else if (property === 'created') {
        comparison = a.created - b.created;
      }
      return comparison * multiplier;
    });

    // Toggle the sort direction for next click
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }
  public openShopProfile() {
    this.addProductComponent.open_shop_info_modal();
  }

  private _getShopInfo() {
    if (this.local.getUser()) {
      this.customerService.getMemberShopsProfile().subscribe(
        (response: ApiResponse) => {
          this.shopExist = response?.message != 'Not Exists';
          // this.shopInfo = response.body;
          if (this.shopExist) {
            this._getCategoryList();
          }
        },
        ({ error }: any) => { }
      );
    }
  }

  public update(action) {
    if (action == 'categoryUpdated') {
      this._getCategoryList();
    } else if (action == 'subCategoryUpdated') {
      this._getSubCategoryList();
    } else if (action == 'productUpdate') {
      this.getAllProductList();
    } else {
      this._getShopInfo();
    }
  }

  private _getCategoryList() {
    this.auth.getAllMemberShopCategory().subscribe((response: any) => {
      this.categoriesList = response.body;
      this.addedCategoryList = response.body;
      if (this.addedCategoryList.length > 0) {
        this.selectedCategoryName = this.addedCategoryList[0].name;
        this._getSubCategoryList();
      } else {
        this.selectedCategoryName = this.categoriesList[0].name;
      }
    });
  }

  private _getSubCategoryList(selectedSubCategoryName = '') {
    let selectedCategoryId = this._getSelectedCategoryId(); // Need update
    this.auth
      .getAllMemberShopSubCategory({
        categoryId: selectedCategoryId,
      })

      .subscribe((response: any) => {
        this.addedSubCategoryList = response.body;
        this.selectedSubCategoryName = '';
      });
  }

  public addProduct() {
    // Validation
    if (this.productAllProductList.filter(i => i[this.filterProp] == this.filterValue).length >= 3) {
      this.toastr.error('Only Three Product can be added!');
      return;
    }

    const user = this.local.getUser()

    this.selectedCategoryName = null;
    this.selectedSubCategoryName = "";
    this.addProductComponent.selectedCatId = "";
    this.addProductComponent.selectedsubCatId = "";
    this.addProductComponent.memberShopProductType = this.filterValue;;
    this.addProductComponent.selectedSubRegionId = user.region;
    this.addProductComponent.newProduct();
    // }
  }

  private _addSubCategory(selectedCategoryId) {
    this.auth
      .addMemberProductSubCategory({
        categoryId: selectedCategoryId,
        name: this.selectedSubCategoryName,
      })

      .subscribe((resp: ApiResponse) => {
        this.addedSubCategoryList = resp.body;
        let selectedSubCategoryId = this._getSelectedSubCategoryId();
        this.addProductComponent.selectedCatId = selectedCategoryId;
        this.addProductComponent.selectedsubCatId = selectedSubCategoryId;
        this.addProductComponent.memberShopProductType = this.filterValue;;
      });
  }

  public openShopAction(action, productId = 0, cate = '', subcate = ''): void {

    this.selectedCategoryName = cate;
    this.selectedSubCategoryName = subcate;
    let selectedCategoryId = this._getSelectedCategoryId();
    let selectedSubCategoryId = this._getSelectedSubCategoryId();


    if (action == 'add_category') {
      this.addProductComponent.newTab();
    } else if (action == 'add_sub_category') {
      this.addProductComponent.selectedCatId = selectedCategoryId;
      this.addProductComponent.newTab('sub');
    } else if (action == 'edit_category') {
      this.addProductComponent.categories = this.categoriesList;
      this.addProductComponent.openEditCatModal();
    } else if (action == 'add_product') {
      this.addProduct();
    } else if (action == 'edit_product' && productId) {
      // this.addProductComponent.isRecommendedProduct = (this.tabs[this.selMenu].title.toLocaleLowerCase() == 'recommendation');
      this.addProductComponent.memberShopProductType = this.filterValue;;
      this.addProductComponent.selectedCatId = selectedCategoryId;
      this.addProductComponent.selectedsubCatId = selectedSubCategoryId;
      this.addProductComponent.editProductModal(productId);
    } else if (action == 'delete_product' && productId) {
      this.addProductComponent.delete_food(productId);
    }
  }

  private _getSelectedCategoryId(): any {
    return (
      this.addedCategoryList.filter(
        (i: any) => i.name == this.selectedCategoryName
      )[0]?.id || 0
    );
  }

  private _getSelectedSubCategoryId(): any {
    return (
      this.addedSubCategoryList.filter(
        (i: any) => i.name == this.selectedSubCategoryName
      )[0]?.id || 0
    );
  }

  public onCategoryChange(catName, subCatName): void {
    this._getSubCategoryList(subCatName);
  }

  public productAllProductList: Array<any> = [];
  public productAllProductListFiltered: Array<any> = [];
  public getAllProductList(selectMenu = false) {
    this.productAllProductList = [];
    this.customerService.getAllShopProduct({
      categoryId: '',
      subCategoryId: '',
    })

      .subscribe(
        (response: any) => {
          this.productAllProductList = response.body;


          this.selectMenu(this.selMenu)
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  public selMenu: any = 0;
  public filterProp = 'type';
  public filterValue: any = 'shop';
  public selectMenu(menu: any): void {
    this.selMenu = menu;
    let values = []
    if (menu == 2) {
      this.filterProp = 'type'
      this.filterValue = 'bless';
      values = ['bless']
    } else if (menu == 1) {
      this.filterProp = 'type'
      this.filterValue = 'rental';
      values = ['rental']
    } else if (menu == 3) {
      this.filterProp = 'type'
      this.filterValue = 'sold';
      values = ['sold']
    } else {
      this.filterProp = 'type';
      this.filterValue = 'shop';
      values = ['shop', 'hide']
    }
    this.filteringProduct(values)
  }

  public filteringProduct(values = []) {
    this.productAllProductListFiltered = this.productAllProductList.filter(
      (row) => values.includes(row[this.filterProp])
    )
  }

  public onRegionClick(e, selected: string) {
    e.stopPropagation();
    this.selectedRegionForDD = (this.selectedRegionForDD == selected) ? '' : selected;
  }

  public onSubRegionClick(selected: string) {
    this.addProductComponent.memberShopProductType = this.filterValue;
    this.selectedSubCategoryName = selected;
    this.addProductComponent.selectedsubCatId = this._getSelectedSubCategoryId();
    if (this.selectedSubCategoryName && this.addProductComponent.selectedsubCatId == 0) {
      this._addSubCategory(this._getSelectedCategoryId());
    }
  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  public onSellOptChange(selectedItem, modal, value) {
    if (value) {
      this.selectedSellOption = { selectedProduct: selectedItem, option: value };
      this.commonModalRef = this.modalService.open(modal, {
        size: "sm",
        ariaLabelledBy: "modal-basic-title",
        windowClass: "suggestion",
      });
    }
  }

  public updateProductStatus() {
    this.auth.updatedMemberShopProductType({ productId: this.selectedSellOption?.selectedProduct?.id, productType: this.selectedSellOption?.option })

      .subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModalRef.close();
        this.getAllProductList();
      }, ({ error }) => {
        this.toastr.error(error.message);
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

